// Minimal replacement for `vuex-router-sync` (incompatible with Vue Router 4
// / Vue 3, removed in B2.1). Several Vuex getters depend on
// `rootState.route.params` (e.g. auth.getCurrentAccountId). This restores the
// exact `store.state.route` shape vuex-router-sync provided, by registering a
// `route` module and keeping it in sync via the router's afterEach hook.
const toRouteState = (route) => {
  if (!route) {
    return {
      name: null,
      path: '/',
      hash: '',
      query: {},
      params: {},
      fullPath: '/',
      meta: {},
    };
  }
  return {
    name: route.name || null,
    path: route.path || '/',
    hash: route.hash || '',
    query: route.query || {},
    params: route.params || {},
    fullPath: route.fullPath || route.path || '/',
    meta: route.meta || {},
  };
};

export const syncRouteToStore = (store, router) => {
  const current =
    router.currentRoute && 'value' in router.currentRoute
      ? router.currentRoute.value
      : router.currentRoute;

  store.registerModule('route', {
    namespaced: false,
    state: toRouteState(current),
    mutations: {
      ROUTE_CHANGED(state, route) {
        const next = toRouteState(route);
        Object.keys(next).forEach((key) => {
          state[key] = next[key];
        });
      },
    },
  });

  router.afterEach((to, _from, failure) => {
    // Vue Router 4 runs afterEach even when a component guard aborts the
    // navigation. Committing `to` in that case would make Vuex point at a
    // different account while the URL and mounted page stay on the original
    // tenant.
    if (failure) return;

    store.commit('ROUTE_CHANGED', to);
  });
};

export default syncRouteToStore;
